import React, { useState, useRef, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
  const form = useRef();
  const [isSent, setIsSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_m21l1as',
        'template_eamvjg9',
        form.current,
        'rKhWDN_wjhBLSdxRx'
      )
      .then(
        (result) => {
          console.log(result.text);
          setIsSent(true);
          resetForm();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const resetForm = () => {
    form.current.reset();
  };

  useEffect(() => {
    let timer;
    if (isSent) {
      timer = setTimeout(() => {
        setIsSent(false);
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [isSent]);

  return (
    <div className="contact section-p">
      <div className="container">
        <div className="contact-section">
          <div className="section-title">
            <h3 className="text-brown">
              contacta <span className="text-dark">con nosotros</span>
            </h3>
            <p className="text">Ofrecemos las soluciones inmobiliarias adecuadas para tu negocio.</p>
          </div>
        </div>

        <form className="contact-form mx-auto" ref={form} onSubmit={sendEmail}>
          <div className="form-elem">
            <input type="text" name="user_name" className="form-control" placeholder="Nombre" />
          </div>
          <div className="form-elem">
            <input type="email" name="user_email" className="form-control" placeholder="Correo Electrónico" />
          </div>
          <div className="form-elem">
            <textarea rows="2" name="message" className="form-control" placeholder="Mensaje"></textarea>
          </div>
          <button type="submit" className="bg-brown text-white submit-btn fw-3 fs-22">
            Enviar
          </button>
        </form>

        <div className={`success-message ${isSent ? '' : 'hide'}`}>
          <p>El mensaje ha sido enviado. Nos pondremos en contacto contigo por correo electrónico pronto. ¡Gracias!</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
